/**
 * Date-extensions locale Albanian [sq]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('sq', {
    monthNames: ['Janar','Shkurt','Mars','Prill','Maj','Qershor','Korrik','Gusht','Shtator','Tetor','Nëntor','Dhjetor'],
    monthShortNames: ['Jan','Shk','Mar','Pri','Maj','Qer','Kor','Gus','Sht','Tet','Nën','Dhj'],
    dayNames: ['E Diel','E Hënë','E Martë','E Mërkurë','E Enjte','E Premte','E Shtunë'],
    dayShortNames: ['Die','Hën','Mar','Mër','Enj','Pre','Sht']
});
